export default "__VITE_ASSET__C6Vl_gy3__"